const ARRIVAL_TYPE = 'arrival';
const DEPART_DIRECTION = 'depart';
const DEPARTURE_TYPE = 'departure';
const MULTIMODAL_TYPE = 'multi';
const RETURN_DIRECTION = 'return';
const ROUTED_TRIP_DELIMITER = '|';
const TEN_MINUTES_IN_MS = 10 * 60 * 1000;
const TRIP_TTL_IN_MS = TEN_MINUTES_IN_MS;

export {
    ARRIVAL_TYPE,
    DEPARTURE_TYPE,
    DEPART_DIRECTION,
    MULTIMODAL_TYPE,
    RETURN_DIRECTION,
    ROUTED_TRIP_DELIMITER,
    TRIP_TTL_IN_MS,
};
